import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  ContextActionsDirective,

} from '@alfresco/aca-shared';


import { NgModule } from '@angular/core';
import { DropdownListComponent } from './dropdown-list.component';
import { ButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownTreeModule, MultiSelectAllModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';


@NgModule({
  declarations: [
    DropdownListComponent,
  ],
  exports: [
    DropdownListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ContextActionsDirective,
    FormsModule, ReactiveFormsModule, ButtonModule, DropDownTreeModule, MultiSelectAllModule, CheckBoxModule, DropDownListModule

  ]
})
export class DropdownListModule { }
